import React,{Fragment, useState} from 'react';
import RecordsTable from './recordsTable';
import {useFetch} from '../../lib/useFetch';
import PaginationBar from '../../components/pagination';

const userHeaders = ["flag", "name", "code", "currency", "price per kg", "min rewward", "fees percentage"];

const mapResponseData = (data) => {
  const getTrimmedObj = (obj) =>{
    let trimmedObj = {}
    trimmedObj['id'] = obj['_id'];
    trimmedObj['flag'] = obj['countryFlag'];
    trimmedObj['name'] = obj['name'];
    trimmedObj['code'] = obj['countryCode'];
    trimmedObj['currency'] = obj['currency'];
    trimmedObj['pricePerKg'] = obj['pricePerKg'];
    trimmedObj['minReward'] = obj['minTravelerReward'];
    trimmedObj['feesReward'] = obj['moveitFeesPercentageOfTheTravelerReward'];
    
    return trimmedObj;
  }

  if (data){
    return data.map(obj => getTrimmedObj(obj));
  }

  return [];
}

const Countries = ({openMainModal}) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [reload, toggleReload] = useState(false)

  const onSearch = (term) => {
    setSearchQuery(term);
    setPage(1);
  };

  const searchParam = searchQuery ? `&search=${encodeURIComponent(searchQuery)}` : '';
  const {data, loading, totalCount} = useFetch(`countries?page=${page}${searchParam}`, reload);

  return(
    <Fragment>
      <RecordsTable
        loading={loading}
        headers={userHeaders}
        records={mapResponseData(data)}
        openMainModal={openMainModal}
        reload={()=>toggleReload(r=> !r)}
        searchQuery={searchQuery}
        onSearch={onSearch}
      />
      <PaginationBar page={page} totalCount={totalCount}  setPage={setPage}/>
    </Fragment>
  );
}

export default Countries;